module.exports = "/_next/static/resources/pack-bd67514371370cbcbc7b01ccd1534250.jpg";